import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router-dom";
import {formatRoute} from 'react-router-named-routes';

import AuthLayout from "../../shared/containers/AuthLayout";
import {getSeniors} from "../members/actions/seniorsAction";
import {
  RC_STATUS_OFFLINE,
  RC_USER_PREFIX_T
} from "../../shared/modules/rocketChat/constants";
import ContactList from "../../shared/components/ContactList";
import * as messageAction from "./actions/messageAction";
import {hash} from "../../shared/actions";
import {ROUTER_MESSAGE_SENIOR} from "../../shared/constants/routers";
import { sendAnalyticsEvent } from "../../shared/actions/analytics";
import { ANALYTICS_SPECS } from "../../shared/constants";


export class SeniorListContainer extends React.Component {
  static propTypes = {
    seniors: PropTypes.array,
    user: PropTypes.object,
    onLeft: PropTypes.func,
    onRight: PropTypes.func,
    onStartClick: PropTypes.func
  };

  static defaultProps = {
    seniors: [],
    user: {}
  };

  componentDidMount() {
    this.props.dispatch(getSeniors());
  }

  onMemberClick = async (user) => {
    sendAnalyticsEvent(
      ANALYTICS_SPECS.MESSAGING.NAME,
      ANALYTICS_SPECS.MESSAGING.EVENTS.SELECT_MESSAGE_CONTACT,
      { contact_list_id: user.prof_id });
    await this.props.onStartClick(user);
    this.props.history.push(formatRoute(ROUTER_MESSAGE_SENIOR, {seniorHash: hash(user)}));
  };

  render() {
    const { seniors } = this.props;

    return (
      <AuthLayout
        title={__("Messages")}
        description={__("Who do you want to write to?")}
      >
        <ContactList
          seniorGroups={[{"title": __("Seniors"), "list": seniors}]}
          onMemberClick={this.onMemberClick}
          left={this.props.onLeft}
          right={this.props.onRight}
        />
      </AuthLayout>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    seniors: state.seniors,
    user: state.user,
    message: state.message,
    rocketChat: state.rocketChat
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
    onStartClick: (user) => dispatch(messageAction.start(RC_USER_PREFIX_T + user))
  };
};

const mergeState = (state, dispatch, own) => {
  return {
    ...own,
    ...state,
    ...dispatch,
    onLeft: (user) => {
      const username = RC_USER_PREFIX_T + user;
      const userStatus = (Object
          .values(state.rocketChat.users)
          .find((rocketChatUser) => rocketChatUser.username === username) || {}
      ).status || RC_STATUS_OFFLINE;

      return (
        <div className={userStatus}>
        </div>
      );
    },
    onRight: (user) => {
      const username = RC_USER_PREFIX_T + user;

      return (
        <div>
          {username in state.message.missed && state.message.missed[username] > 0
            ? <span
              className="missedContactCount">{state.message.missed[username]}</span>
            : ''}
          <i className="fa fa-envelope"/>
        </div>
      );
    }
  }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps, mergeState)(SeniorListContainer));
